module.exports = __webpack_public_path__ + "img/gsb10.c71f5384.png";